
    <div class="results-container">
        <!-- Success Count -->
        <div class="result-section success-section" *ngIf="successCount > 0">
            <i class="pi pi-check-circle success-icon"></i>
            <div class="result-details">
                <h3>{{successCount}} {{entityType}} Created Successfully</h3>
                <p>All successful {{entityType}} were processed</p>
            </div>
        </div>

        <!-- Error Count -->
        <div class="result-section error-section" *ngIf="errorCount > 0">
            <i class="pi pi-exclamation-triangle error-icon"></i>
            <div class="result-details">
                <h3>{{errorCount}} {{entityType}} Failed</h3>
                <p>See details below for specific errors</p>
            </div>
        </div>

        <!-- Error Details -->
        <div class="error-details" *ngIf="errorMessages.length > 0">
            <p-accordion [value]="isErrorDetailsOpen ? ['0'] : null">
                <p-accordion-panel value="0">
                    <p-accordion-header>View Error Details</p-accordion-header>
                    <p-accordion-content>
                        <p-listbox [options]="errorMessages" [style]="{'width':'100%'}"></p-listbox>
                    </p-accordion-content>
                </p-accordion-panel>
            </p-accordion>
        </div>

        <div class="bottom-gap"></div>
    </div>
    <!-- <ng-template pTemplate="footer">
        <p-button (click)="visible = false" label="Close" styleClass="p-button-text"></p-button>
    </ng-template> -->

    <div class="action-footer">
    <p-button (onClick)="closeDialog()" label="Close"></p-button>
</div>
